import React, { memo, useCallback, useEffect, useState } from 'react';

import { NumberInput } from '@sravni/react-design-system';
import { usePrevious } from '@sravni/react-utils';

import { IPromoBlockProps } from '../Blocks/BigBlock';

export const CreditForm = memo<IPromoBlockProps>(({ setValue: setValueAtParentBlock, handleEnterEvent }) => {
  const [value, setValue] = useState<'' | number>();
  const prevValue = usePrevious(value);

  useEffect(() => {
    if (prevValue === value) return;

    setValueAtParentBlock(value);
  }, [prevValue, setValueAtParentBlock, value]);

  const handleChange = useCallback((value: number) => {
    setValue(value);
  }, []);

  return (
    <NumberInput
      label={'Укажите сумму'}
      value={value}
      onChange={handleChange}
      thousandSeparator={' '}
      postfix={'₽'}
      onKeyUp={handleEnterEvent}
      defaultValue={''}
    />
  );
});
